module.exports = __webpack_public_path__ + "static/img/logo.b1d30f80.png";